<template>
    <div class="row">
      <loading
        :active.sync="loader.isLoading"
        :can-cancel="loader.canCancel"
        :is-full-page="loader.fullPage"
        :color="loader.color"
        :height="loader.height"
        :width="loader.width"
        :background-color="loader.backgroundColor"
        :loader="loader.loader">
        </loading>
        <div class="col-md-12">
          <div class="table-responsive">
            <div class="form-inline ml-auto">
              <div class="button-group">
                <select class="form-control mr-2" v-model="company">
                  <option value="">-- All --</option>
                  <option v-for="c in companyList" :key="c.id" :value="c.company_no">{{ c.name }}</option>
                </select>
                <button type="button" class="btn btn-sm  btn-soft-outline-primary waves-light waves-effect" @click="refreshList">
                  <i class="fa fa-refresh" aria-hidden="true"></i> Refresh
                </button>
                <!-- <button type="button" class="btn btn-sm btn-soft-primary waves-light waves-effect" data-toggle="modal" data-target="#modalCustomerBirthday" data-backdrop="static" data-keyboard="false">Send Birthday</button> -->
                <!-- <button type="button" class="btn btn-sm btn-soft-primary waves-lithg waves-effect" @click="sendMessage">Test</button> -->
                <button class="btn btn-warning btn-sm dropdown-toggle" type="button" id="print" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  <i class="fa fa-print" aria-hidden="true"></i> Print
                </button>
                <div class="dropdown-menu" aria-labelledby="print">
                  <a class="dropdown-item" href="javascript:void(0)" @click="print('pdf')">PDF</a>
                  <a class="dropdown-item" href="javascript:void(0)" @click="print('excel')">Excel</a>
                </div>
                rows:
                <select id="select-rows" v-model="pageSize" @change="setPageSizeOnChange">
                  <option v-for="r in rowsTable" :key="r.row" :value="r.row">{{ r.row }}</option>
                </select>
                <span class="mr-1">
                  Total rows: <b>{{ rowsTotal }}</b>
                </span>
                <date-picker v-model="startDate" type="date" range placeholder="Select date range" @change="refreshList"></date-picker>
              </div>
              <div class="form-group mx-sm-3 mb-2">
                  <input type="search" placeholder="search..." class="form-control mr-1 input-search" v-model="searchQuery">
              </div>
              <span class="mr-1">
                page:
                <select v-model="currentPage">
                  <option v-for="p in pageLength" :key="p" :value="p">{{ p }}</option>
                </select>
                / {{ pageLength }}
              </span>
              <nav aria-label="Page navigation example" class="pull-right">
                  <ul class="pagination">
                      <li class="page-item">
                          <a class="btn btn-default btn-sm" href="#" @click="prevPage">
                              <i class="fa fa-angle-left" aria-hidden="true"></i>
                          </a>
                      </li>
                      <li class="page-item">
                          <a class="btn btn-default btn-sm" href="#" @click="nextPage">
                              <i class="fa fa-angle-right" aria-hidden="true"></i>
                          </a>
                      </li>
                  </ul>
              </nav>
            </div>
            <table class="table table-item mb-0 table-sm table-hover">
                <thead>
                    <tr>
                        <!-- <th>
                          <label class="form-checkbox">
                            <input type="checkbox" v-model="selectAll" @click="select">
                            <i class="form-icon"></i>
                          </label>
                        </th> -->
                        <th  v-for="t in title" v-bind:key="t.prop" @click="sortTable(t.prop)" :class="t.align">
                            {{ t.name }}
                            <div class="float-right fa" v-if="t.prop == sortColumn" v-bind:class="ascending ? 'fa-arrow-up' : 'fa-arrow-down'"></div>
                        </th>
                    </tr>
                </thead>
                <tbody>
                  <tr v-if="filterData.length < 1">
                    <td colspan="9" style="text-align: center;"><i>No Data</i></td>
                  </tr>
                    <tr v-for="u in filterData" v-bind:key="u.id" style="cursor: pointer">
                        <td>{{ u.sale_no}}</td>
                        <td>{{ u.sale_date | dateFormat('DD/MM/YYYY') }}</td>
                        <td>{{ u.sale_due_date | dateFormat('DD/MM/YYYY') }}</td>
                        <td><b>[{{ u.product_no}}] {{ u.description }}</b></td>
                        <td class="text-right">{{ u.price | currency }}</td>
                        <td class="text-right">{{ u.subtotal | currency }}</td>
                        <td class="text-right">{{ u.discount | currency }}</td>
                        <td class="text-right">{{ u.tax | currency }}</td>
                        <td class="text-right">{{ u.total | currency }}</td>
                    </tr>
                </tbody>
            </table>
          </div>
      </div>
      <CustomerBirthdayModal @setBirthday="setBirthday"/>
      <SaleOrderModal />
    </div>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import { customerUrl, customer2Url, getHeader } from '@/config'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import CustomerBirthdayModal from '@/components/customer/CustomerBirthdayModal.vue'
import SaleOrderModal from '@/components/sales/SaleOrderModal.vue'
import DatePicker from 'vue2-datepicker'

export default {
  name: 'CustomerSaleProductList',
  components: {
    Loading,
    DatePicker,
    CustomerBirthdayModal,
    SaleOrderModal
  },
  props: ['customer'],
  data () {
    var date = new Date()
    var firstDay = new Date(date.getFullYear(), date.getMonth(), 1)
    var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0)
    const date1 = new Date(firstDay.getFullYear(), firstDay.getMonth(), firstDay.getDate())
    const date2 = new Date(lastDay.getFullYear(), lastDay.getMonth(), lastDay.getDate())
    return {
      startDate: [date1, date2],
      company: null,
      dateNow: new Date(),
      loader: {
        isLoading: false,
        fullPage: true,
        color: '#007bff',
        canCancel: true,
        height: 128,
        width: 128,
        backgroundColor: '#ffffff',
        loader: 'spinner'
      },
      dataRaw: [],
      data: {},
      searchQuery: '',
      ascending: false,
      sortClick: false,
      sortColumn: '',
      pageSize: 25,
      currentPage: 1,
      title: [{
        name: 'Sale No',
        prop: 'sale_no',
        align: 'text-left'
      }, {
        name: 'Date',
        prop: 'sale_date',
        align: 'text-left'
      }, {
        name: 'Due Date',
        prop: 'sale_due_date',
        align: 'text-left'
      }, {
        name: 'Product',
        prop: 'product_no',
        align: 'text-left'
      }, {
        name: 'Price',
        prop: 'price',
        align: 'text-right'
      }, {
        name: 'DPP',
        prop: 'subtotal',
        align: 'text-right'
      }, {
        name: 'Discount',
        prop: 'discount',
        align: 'text-right'
      }, {
        name: 'Tax',
        prop: 'tax',
        align: 'text-right'
      }, {
        name: 'Total',
        prop: 'total',
        align: 'text-right'
      }],
      selectAll: false,
      selected: []
    }
  },
  mounted () {
    this.refreshList()
  },
  computed: {
    ...mapState({
      rowsTable: state => state.data.rowsTable,
      companyList: state => state.companies.companyList,
      authUser: state => state.users.authUser
    }),
    pageLength: function () {
      var count = 0
      if (this.searchQuery.length < 0 || this.searchQuery === null) {
        count = this.dataRaw.length
      } else {
        count = this.dataRaw
          .filter(d => {
            for (const name in d) {
              if (d[name] !== null) {
                if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
                  return d
                }
              }
            }
          }).length
      }
      var length = count / this.pageSize

      return Math.ceil(length)
    },
    rowsTotal: function () {
      var count = 0
      if (this.searchQuery.length < 0 || this.searchQuery === null) {
        count = this.dataRaw.length
      } else {
        count = this.dataRaw
          .filter(d => {
            for (const name in d) {
              if (d[name] !== null) {
                if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
                  return d
                }
              }
            }
          }).length
      }
      // console.log(count)
      return count
    },
    filterData: function () {
      if (this.searchQuery.length > 0) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      }
      var col = this.sortColumn
      var ascending = this.ascending
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return this.dataRaw.sort(function (a, b) {
        if (a[col] > b[col]) {
          return ascending ? 1 : -1
        } else if (a[col] < b[col]) {
          return ascending ? -1 : 1
        }
        return 0
      }).filter(d => {
        for (const name in d) {
          if (d[name] !== null) {
            if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
              return d
            }
          }
        }
      }).filter((row, index) => {
        const start = (this.currentPage - 1) * this.pageSize
        const end = this.currentPage * this.pageSize
        if (index >= start && index < end) return true
      })
    }
  },
  methods: {
    async getOrderNo (order) {
      var payload = {
        order_no: order
      }
      this.$store.dispatch('getOrderByNo', payload)
    },
    sendMessage: function () {
      var obj = {
        number: '085950325293',
        message: 'Selamat ulang tahun \n\n Terima kasih',
        key: '035c6f2f79a8284cd7a2cfafc01fc713'
      }
      axios.post('localhost:8081/send-message', obj)
        .then(response => {
          console.log(response)
        })
        .catch(error => {
          console.log(error.response)
        })
    },
    setBirthday: function (value) {
      axios.post(customerUrl + '/birthday', value, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          console.log(response.data.data)
          this.dataRaw = response.data.data
          if (response.data.data.length === 0) {
            this.refreshList()
          }
          this.$swal(
            'Sucess',
            response.data.message,
            'success'
          )
        })
        .catch(error => {
          console.log(error.response)
          this.$swal(
            'Error',
            error.response.data.message,
            'error'
          )
        })
    },
    setPageSizeOnChange: function () {
      this.currentPage = 1
    },
    sortTable: function sortTable (col) {
      this.currentPage = 1
      if (this.sortColumn === col) {
        this.ascending = !this.ascending
      } else {
        this.ascending = true
        this.sortColumn = col
      }
    },
    nextPage: function () {
      if ((this.currentPage * this.pageSize) < this.rowsTotal) this.currentPage++
    },
    prevPage: function () {
      if (this.currentPage > 1) this.currentPage--
    },
    select () {
      this.selected = []
      this.currentPage = 1
      if (!this.selectAll) {
        for (const i in this.filterData) {
          this.selected.push(this.filterData[i].id)
        }
      }
    },
    editCustomer (id) {
      // this.data = this.dataRaw.find(todo => todo.id === id)
      axios.get(customerUrl + '/' + id, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.$emit('editCustomer', response.data.data)
        })
        .catch(response => {
          this.$swal(
            'Error!!!',
            response,
            'error'
          )
        })
    },
    addCustomer () {
      this.$emit('newCustomer', true)
    },
    refreshList () {
      this.$Progress.start()
      this.loader.isLoading = true
      const begin = this.startDate[0] ? this.startDate[0].getFullYear() + '-' + (this.startDate[0].getMonth() + 1) + '-' + this.startDate[0].getDate() : null
      const end = this.startDate[1] ? this.startDate[1].getFullYear() + '-' + (this.startDate[1].getMonth() + 1) + '-' + this.startDate[1].getDate() : null
      var data = {
        begin: begin,
        end: end,
        customer_no: this.customer.customer_no,
        company_no: this.company
      }
      console.log(data)
      axios.post(customerUrl + '/sale-details', data, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.dataRaw = response.data.data
          this.$Progress.finish()
          this.loader.isLoading = false
          this.currentPage = 1
          this.searchQuery = ''
          console.log(response.data.data)
        })
        .catch(error => {
          this.loader.isLoading = false
          if (error === 'Error: Network Error') {
            window.localStorage.removeItem('authUser')
            this.$router.push({ name: 'login' })
          } else if (error.response.data.message === 'This action is unauthorized.') {
            window.localStorage.removeItem('authUser')
            this.$router.push({ name: 'login' })
          }
        })
    },
    async print (type) {
      this.$Progress.start()
      this.loader.isLoading = true
      var data = {
        format: type,
        customer_no: this.customer.customer_no,
        customer: this.customer.name,
        data: this.dataRaw
      }
      if (data.length === 0) {
        this.$swal('Error', 'Data masih kosong', 'error')
        return false
      }
      console.log(data)
      await axios.post(customer2Url + '/sale-by-product', data, { responseType: 'blob' })
        .then(response => {
          const objectUrl = URL.createObjectURL(response.data)
          console.log('Showing PDF...')
          window.open(objectUrl, '_blank')
          this.$Progress.finish()
          this.loader.isLoading = false
        })
        .catch(error => {
          this.$Progress.finish()
          this.loader.isLoading = false
          console.log(error)
          console.log(error.response)
        })
    }
  }
}
</script>
